import { render } from "./BlockKerjaTable.vue?vue&type=template&id=d4d752d8"
import script from "./BlockKerjaTable.vue?vue&type=script&lang=js"
export * from "./BlockKerjaTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__